import React, { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import Header from './utils/web/Header/Header';
import Footer from './utils/web/Footer/Footer';
function WebLayout() {

    return (
        <div className="jewellery-web">
            <Header />
            <Outlet />
            <Footer />
        </div>
    );
}

export default WebLayout;